import { sharedAtlantikiFields } from '@/views/checkouts/companies/Atlantiki/shared/sharedAtlantikiSchema';
import * as yup from 'yup';

export const BikeAtlantikiSchemaBuilder = (
  firstDriverAdditionalPremiumAge,
  secondDriverAdditionalPremiumAge,
  firstDriverAdditionalPremiumLicenseYears,
  secondDriverAdditionalPremiumLicenseYears,
  legalEntity,
  secondDriver,
  discountEntity,
  vehicleType
) => {
  return yup.object({
    ...sharedAtlantikiFields(
      firstDriverAdditionalPremiumAge,
      secondDriverAdditionalPremiumAge,
      firstDriverAdditionalPremiumLicenseYears,
      secondDriverAdditionalPremiumLicenseYears,
      legalEntity,
      secondDriver,
      discountEntity,
      vehicleType
    ),
  });
};

export default BikeAtlantikiSchemaBuilder;
